/**
 * API Users pour Anamnesis
 * Utilise l'authentification JWT et correspond aux endpoints backend
 */

import { apiClient } from '@/services/api';
import type { User, UserCreate, UserUpdate } from './types/core/users';

// @deprecated Use imports from '@/api/types' instead
export type {
  User,
  UserCreate,
};

// Fonctions séparées pour la compatibilité
export async function fetchUserById(uuid: string): Promise<User> {
  return users.fetchUserById(uuid);
}

export async function fetchAllUsers(): Promise<User[]> {
  return users.fetchAllUsers();
}

export async function createUser(userData: UserCreate): Promise<User> {
  return users.createUser(userData);
}

export async function updateUser(uuid: string, userData: Partial<UserUpdate>): Promise<User> {
  return users.updateUser(uuid, userData);
}

export async function deleteUser(uuid: string): Promise<void> {
  return users.deleteUser(uuid);
}

export const users = {
  /**
   * Récupère un utilisateur par son UUID
   */
  async fetchUserById(uuid: string): Promise<User> {
    const response = await apiClient.get<User>(`/users/by_id/${uuid}`);
    return response.data;
  },

  /**
   * Récupère tous les utilisateurs (admin uniquement)
   */
  async fetchAllUsers(): Promise<User[]> {
    const response = await apiClient.get<User[]>('/users/all');
    return response.data;
  },

  /**
   * Crée un nouvel utilisateur (admin uniquement)
   */
  async createUser(userData: UserCreate): Promise<User> {
    const response = await apiClient.post<User>('/users/', userData);
    return response.data;
  },

  /**
   * Met à jour un utilisateur
   */
  async updateUser(uuid: string, userData: Partial<UserUpdate>): Promise<User> {
    const response = await apiClient.put<User>(`/users/by_id/${uuid}`, userData);
    return response.data;
  },

  /**
   * Supprime un utilisateur (admin uniquement)
   */
  async deleteUser(uuid: string): Promise<void> {
    await apiClient.delete(`/users/by_id/${uuid}`);
  },

  /**
   * Récupère le profil de l'utilisateur connecté
   */
  async getCurrentUser(): Promise<User> {
    const response = await apiClient.get<User>('/auth/me');
    return response.data;
  },

  /**
   * Met à jour le profil de l'utilisateur connecté
   */
  async updateCurrentUser(userData: Partial<UserUpdate>): Promise<User> {
    // Pour l'instant, on utilise l'endpoint générique
    // TODO: Créer un endpoint spécifique /auth/profile si nécessaire
    const currentUser = await this.getCurrentUser();
    return this.updateUser(currentUser.uuid, userData);
  }
};
